import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HelpersService } from '../../services/tools/helpers.service';
import { GastosService } from '../../services/gastos.service';
import { DatesHelpersService } from '../../services/tools/dates-helpers.service';
import { SucursalesService } from '../../services/sucursales.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoriasGastosService } from '../../services/categorias-gastos.service';
import { Location } from '@angular/common';
import { Color } from 'ng2-charts';
import { ChartOptions, ChartType } from 'chart.js';

@Component({
  selector: 'app-gastos-categoria',
  templateUrl: './gastos-categoria.component.html',
  styleUrls: ['./gastos-categoria.component.scss']
})
export class GastosCategoriaComponent implements OnInit {
  public : any [] = [];
  public isLoading: boolean = false;
  //Filters 
  public searchText: string = '';
  //Pagination vars
  public page: number = 1;
  public fechaInicio: string = null;
  public fechaFin: string = null;
  public sucursales: any[] = [];
  public sucursal: any = {id:null};
  public sucursalPorDefecto: string = "";
  public gastosSubcategorias : any[];
  public categoria : any;
  public totalListaGastos: number =0;
  public mesURL: string ="";
  //Bandera para saber si ya se tienen datos para graficar
  public muestraGraficaDona: boolean = true;

  // Doughnut - gráfica
  public doughnutChartLabels: string[];
  public doughnutChartData: number[];
  public doughnutChartType: ChartType;
  public doughnutChartColors: Color[];
  public doughnutChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: true
    },
  };
  public chartClickedDona(e:any): void {
    console.log("Error: ",e);
    //console.log(e.active[0]._view);
  }
  public chartHoveredDona(e:any): void {
    console.log("Error: ",e);
  }

  constructor(
      private helperService : HelpersService,
      private service : GastosService,
      private categoriasService : CategoriasGastosService,
      private sucursalesService : SucursalesService,
      private datesHelper : DatesHelpersService,
      private router : Router,
      private activatedRoute : ActivatedRoute,
      private location : Location
  ){
  }

  public ngOnInit() {
    this.mesURL = this.activatedRoute.snapshot.params.mes;
    this.sucursal={id:this.activatedRoute.snapshot.params.idSucursal};
    let defaultDates = this.datesHelper.getMonthDate();
    //Definimos el mes seleccionado como fecha inicial para que se muestren las subcategorías
    var mesCategoria = this.nameMesToNumber(this.mesURL.split(" ")[0]);
    var yearCategoria = this.mesURL.split(" ")[1];
    this.fechaInicio = (yearCategoria+"-"+mesCategoria+"-01");
    //this.fechaInicio = defaultDates.fechaInicio;
    this.fechaFin = (yearCategoria+"-"+mesCategoria+"-31");
    //this.fechaFin = defaultDates.fechaFin;
    this.getSucursales();
    this.categoria = this.categoriasService.getDefaultSchedule();
    this.getCategoria(this.activatedRoute.snapshot.params.id);
    
  }

  getCategoria(id : number){
    this.categoriasService.find(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        this.categoria = jsonResult.content;
        this.getGastos();
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public nameMesToNumber(nombreMes: string){
    switch (nombreMes.toLowerCase()){
      case "enero": return 1;
      case "febrero": return 2; 
      case "marzo": return 3;  
      case "abril": return 4; 
      case "mayo": return 5; 
      case "junio": return 6; 
      case "julio": return 7; 
      case "agosto": return 8; 
      case "septiembre": return 9; 
      case "octubre": return 10; 
      case "noviembre": return 11;
      case "diciembre": return 12;
    }
  }

  public getGastos(){
    //Para gráfica de dona
    this.doughnutChartLabels = [];
    this.doughnutChartData = [];
    this.doughnutChartType  = 'doughnut';
    this.doughnutChartColors = [ { backgroundColor: [] }];
    //Colores aleatorios
	  var simbolos = "0123456789ABCDEF";
	  var color = "#";
    //Bandera para mostrar gráfica
    this.muestraGraficaDona = false;

    //Filtros para fecha y sucursal
    if (!this.categoria.id){
      return;
    }
    let filters = {
      "start-date": this.fechaInicio,
      "end-date": this.fechaFin,
      "idCategoriasGastos" : this.categoria.id
    }
    if (this.sucursal.id) {
      filters["idSucursales"] = this.sucursal.id;
    }
    this.isLoading = true;
    var colorsTemp: Array <string> = [];
    this.service.getMetricsByCategory(filters).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        this.gastosSubcategorias = jsonResult.content;
        this.totalListaGastos = 0;
        //Foreach para acceder a los elementos
        console.log("Gastos Sub: ", this.gastosSubcategorias);
        this.gastosSubcategorias.forEach(gastoSub =>{
          this.doughnutChartLabels.push(gastoSub.nombre);
          this.doughnutChartData.push(gastoSub.monto_total);
          //Genera colores aleatorios
          color = "#";
          for(var i = 0; i < 6; i++){
            color = color + simbolos[Math.floor(Math.random() * 16)];
          }
          colorsTemp.push(color);
          this.totalListaGastos = (this.totalListaGastos + gastoSub.monto_total);
        });
        //this.doughnutChartColors[0].backgroundColor=colorsTemp;
      
        //Comprobamos si se tienen datos para graficar
        if (this.doughnutChartData.length === 0){ //Comprueba que el dataset tenga datos para graficar
          this.muestraGraficaDona = false;
        }else{
          this.muestraGraficaDona = true;
        }
        //Bandera que se activa cuando se pasaron los datos para graficar
        this.isLoading = false;
      }, error => 
      {
        this.isLoading = false;
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private getSucursales(){
    this.isLoading = true;
    this.sucursalesService.get().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.sucursales = jsonResult.content.data;
          if (this.sucursales.length>1){
            this.sucursalPorDefecto = "Seleccione";
          } else if(this.sucursales.length>0){
            this.sucursal =  this.sucursales[0];
          }
          this.isLoading = false;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  sucursalChanged(sucursal){
      if(sucursal){
          this.sucursal = sucursal;
          this.getGastos();
      }
  }

  verDetalleGasto(gastoCategoria){
    if (this.sucursal.id) {
      this.router.navigate(["gastos/detalles/subcategoria/"+gastoCategoria.idSubcategoriasGastos+"/"+this.mesURL+"/"+this.sucursal.id]);
    }else{
      this.router.navigate(["gastos/detalles/subcategoria/"+gastoCategoria.idSubcategoriasGastos+"/"+this.mesURL]);
    }
  }

  back(){
    this.location.back();
  }


}



// WEBPACK FOOTER //
// ./src/app/gastos/gastos-categoria/gastos-categoria.component.ts